import cx from 'classnames'
import React from 'react'

interface Props {
  /** Extra classes, e.g. spacing for the surrounding layout. */
  className?: string
  /**
   * Overrides the sentence after "Disclaimer:". Defaults to the summary wording;
   * pass your own where "summary" does not fit (e.g. a comparison result).
   */
  children?: React.ReactNode
}

/**
 * Standard notice shown alongside any AI-generated content, so the wording and
 * data-residency statement stay identical everywhere it appears.
 */
const AiDisclaimer = ({ className, children }: Props) => (
  <div
    className={cx(
      'rounded-lg bg-grey-100 p-2 border border-solid border-grey-400',
      className
    )}
  >
    <span className="font-bold">Disclaimer:</span>{' '}
    {children ??
      'Generated with Microsoft Azure Open AI. All data is hosted in Australia.'}
  </div>
)

export default AiDisclaimer
